"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _envelope = _interopRequireDefault(require("./envelope"));

var _resultClass = _interopRequireDefault(require("./resultClass"));

var _message = _interopRequireDefault(require("./message"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Tokens = /*#__PURE__*/function () {
  function Tokens() {
    _classCallCheck(this, Tokens);
  }

  _createClass(Tokens, [{
    key: "encryptTokenInfoFromPlain",
    //  Generazione della stringa crittografata delle informazioni di un token
    //  ----------------------------------------------------------------------
    value: function encryptTokenInfoFromPlain(token) {
      var result = _envelope.default.simpleInsert(this.composeTokenInfo(token));

      if (result.code !== _message.default.IS_OK) return result;
      return new _resultClass.default(_message.default.OK, "", result.data);
    } //  Composizione delle informazioni del token
    //  -----------------------------------------

  }, {
    key: "composeTokenInfo",
    value: function composeTokenInfo(token) {
      var appcode = "{".concat(token.appcode, "}");
      var userid = "{".concat(token.userid, "}");
      var scope = "{".concat(token.scope, "}");
      var odbc = "{}";
      var permission = "{}";
      return appcode + userid + scope + odbc + permission;
    } //  Generazione della stringa crittografata di un token in chiaro
    //  -------------------------------------------------------------

  }, {
    key: "generateTokenFromPlain",
    value: function generateTokenFromPlain(token) {
      var result = _envelope.default.insert(this.nowToTokenDate() + this.composeTokenInfo(token));

      if (result.code !== _message.default.IS_OK) return result;
      return new _resultClass.default(_message.default.OK, "", result.data);
    } //  Generazione della stringa crittografata da un token crittografato
    //  -----------------------------------------------------------------

  }, {
    key: "generateTokenFromEncrypted",
    value: function generateTokenFromEncrypted(encrypted) {
      var result = _envelope.default.simpleExtract(encrypted);

      if (result.code !== _message.default.IS_OK) return result;
      result = _envelope.default.insert(this.nowToTokenDate() + result.data);
      if (result.code !== _message.default.IS_OK) return result;
      return new _resultClass.default(_message.default.OK, "", result.data);
    } //  Compattazione della data attuale
    //  --------------------------------

  }, {
    key: "nowToTokenDate",
    value: function nowToTokenDate() {
      var now = new Date();
      var MM = (now.getMonth() + 1).toString().padStart(2, '0');
      var gg = now.getDate().toString().padStart(2, '0');
      var hh = now.getHours().toString().padStart(2, '0');
      var mm = now.getMinutes().toString().padStart(2, '0');
      var ss = now.getSeconds().toString().padStart(2, '0');
      return now.getFullYear() + MM + gg + hh + mm + ss;
    }
  }]);

  return Tokens;
}();

var _default = Tokens;
exports.default = _default;